module.exports = __webpack_public_path__ + "assets/noun_avatar_icn.180805fe.svg";